import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IRootDispatch, dispatch } from 'src/stores/rematch/root-store';
import { Row } from 'antd';
import { ICustomView } from 'src/interfaces/custom-views-interface';
import { CustomViewsModalType } from 'utilities/enum-utils';

export interface IBookingViewTabPopoverProps {
  currentTab: ICustomView;
  onHidePopOver: (isOpen: boolean) => void;
  onShowBookingViewModal: (viewModalType?: CustomViewsModalType) => void;
  doUpdateBookingViewTab: typeof dispatch.bookingsStore.doUpdateBookingView;
}

export interface IBookingViewTabPopoverState {
  isLoading: boolean;
  isSearching: boolean;
  filteredViews: any[];
}

export class BookingViewTabPopover extends Component<IBookingViewTabPopoverProps, IBookingViewTabPopoverState> {
  private _onTogglePinView = async () => {
    const { doUpdateBookingViewTab, currentTab, onHidePopOver } = this.props;
    onHidePopOver(false);
    await doUpdateBookingViewTab({ ...currentTab, isPinned: !currentTab.isPinned, isTogglePinned: true });
  };

  private _onManageView = () => {
    const { onShowBookingViewModal, onHidePopOver } = this.props;
    onHidePopOver(false);
    onShowBookingViewModal(CustomViewsModalType.MANAGE);
  };

  private _onDuplicateView = () => {
    const { onShowBookingViewModal, onHidePopOver } = this.props;
    onHidePopOver(false);
    onShowBookingViewModal(CustomViewsModalType.DUPLICATE);
  };

  render() {
    const { currentTab } = this.props;

    return (
      <div style={{ margin: '-4px -16px' }}>
        <Row
          className="cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest"
          onClick={this._onTogglePinView}
        >
          {currentTab.isPinned ? 'Unpin view' : 'Pin view'}
        </Row>
        {currentTab.isOwner && (
          <Row
            className="cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest"
            onClick={this._onManageView}
          >
            Manage view
          </Row>
        )}
        <Row
          className="cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest"
          onClick={this._onDuplicateView}
        >
          Duplicate view
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: IRootDispatch) => ({
  doUpdateBookingViewTab: dispatch.bookingsStore.doUpdateBookingView,
});

export default connect(null, mapDispatchToProps)(BookingViewTabPopover);
